import { LINKS } from "@/constants/links";

export default function Hero() {
  return (
    <header className="relative px-6 pt-24 pb-20 md:pt-36 md:pb-28 border-b border-[#2a2825] bg-[#121110]" data-testid="hero-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8">
          <p className="font-mono-tag text-xs uppercase tracking-[0.2em] text-[#c9944a] mb-6">Castelli Romani · Marino Centro Storico</p>
          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-display leading-[0.95] tracking-tight mb-8">
            <span className="hero-line"><span>Vacanze Romane</span></span>
            <span className="hero-line"><span className="italic text-[#c9944a]">tra vino e colline.</span></span>
          </h1>
          <p className="fade-in-slow text-lg md:text-xl text-[#a8a095] max-w-xl font-light leading-relaxed">
            60 mq accoglienti per 4 ospiti nel borgo antico, a 30 minuti di treno da Roma e 5 dal lago.
          </p>
        </div>
        <div className="lg:col-span-4 fade-in-slow flex flex-col gap-4">
          <div className="p-6 border border-[#2a2825] bg-[#1a1816]" data-testid="price-card">
            <div className="text-xs uppercase font-mono-tag tracking-wider text-[#9e968b] mb-1">Prezzo Indicativo</div>
            <div className="text-3xl font-display text-[#f4efe8] mb-2" data-testid="price-value">da 85&euro; <span className="text-xs font-sans text-[#a8a095]">/ notte</span></div>
            <div className="text-xs text-[#a8a095] mb-2">Intero appartamento · Fino a 4 ospiti</div>
            <div className="text-xs text-[#9e968b] mb-4 font-mono-tag" data-testid="price-note">Il prezzo varia in base al periodo e alla stagione</div>
            <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="hero-cta-whatsapp" className="block w-full py-3 text-center bg-[#c9944a] text-[#121110] font-medium text-xs uppercase tracking-widest font-mono-tag hover:bg-[#d8a55b] transition-colors">Prenota su WhatsApp</a>
          </div>
        </div>
      </div>
    </header>
  );
}
